import { User } from "../@core/data/users";
import { Employee } from "./employee.model";
import { Person } from "./person.model";
import { Receipt } from "./receipt.model";

export default class WorkingTask {
  id?: string;
  title?: string;
  description?: string;
  coverUrl?: string;
  type?: string; //Task / ...

  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  dueDate?: Date;

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images

  isClosed?: boolean;
  tags?: string[];
  privacy?: boolean;
  status?: number; //0: pending, 1: todo, 2:progress, 3: review, 4: done, 5: reject , 6: finished
  priority?: number; //0: low, 1: medium, 2: high, 3: critical
  level?: number;
  points?: number; //estimated number of points

  todoDate?: Date;
  progressDate?: Date;
  reviewDate?: Date;
  rejectDate?: Date;
  doneDate?: Date;

  persons?: Person[];
  objectType?: string = "customer"; //customer - supplier - employee
  customerId?: string;
  customerName?: string;
  supplierId?: string;
  supplierName?: string;
  employeeId?: string;
  employeeName?: string;
  projectId?: string;
  projectName?: string;

  assignee?: User;
  assignBy?: string;
  assignName?: string;

  noLiked?: number;
  noComment?: number;

  receipt?: Receipt;
  processors?: TaskProcessors[];
  strProcessors?: string;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //Finish
  isFinished?: boolean;
  finishedOn?: Date;
  rating?: number;
  ratingComment?: string;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedName?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class TaskProcessors {
  employee?: Employee;
  role?: string;
}
